export default __webpack_public_path__ + "static/media/opentelemetry.a2cdd406.svg";